/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createLookupAddressResponseFromDiscriminatorValue, serializeLookupAddressRequest, serializeLookupAddressResponse, type ErrorResponse, type InternalErrorResponse, type LookupAddressRequest, type LookupAddressResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/addresses/lookup/public
 */
export interface PublicRequestBuilder extends BaseRequestBuilder<PublicRequestBuilder> {
    /**
     * Returns address predictions for registration flow (rate limited)
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<LookupAddressResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 429 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: LookupAddressRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<LookupAddressResponse | undefined>;
    /**
     * Returns address predictions for registration flow (rate limited)
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: LookupAddressRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PublicRequestBuilderUriTemplate = "{+baseurl}/api/addresses/lookup/public";
/**
 * Metadata for all the requests in the request builder.
 */
export const PublicRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: PublicRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            429: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createLookupAddressResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeLookupAddressRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
